import { useState, useEffect, useRef } from "react";
import { decryptData, fmt, Loading } from "../components/const";
import UseFetch from "../components/UseFetch";
import { NavLink } from "react-router-dom";
import $ from "jquery"
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const exportClientsPDF = (clients, magasin, totalDette) => {
    const doc = new jsPDF();
    const date = new Date().toLocaleDateString('fr-FR');

    doc.setFontSize(14);
    doc.text(`Magasin : ${magasin ?? ''}`, 14, 15);
    doc.setFontSize(11);
    doc.text(`Liste des clients redevables — ${date}`, 14, 23);
    doc.setFontSize(11);
    doc.setTextColor(180, 0, 0);
    doc.text(`Total des dettes : ${fmt(totalDette)} GNF`, 14, 30);
    doc.setTextColor(0, 0, 0);

    const rows = clients
        .filter(c => c.creditTotal > 0)
        .map((c, i) => [
            i + 1,
            c.client,
            c.telephone,
            c.adresse,
            `${(fmt(c.creditTotal))} GNF`,
            (c.agent ?? '').toUpperCase(),
        ]);

    autoTable(doc, {
        startY: 35,
        head: [['N°', 'Client', 'Téléphone', 'Adresse', 'Crédit total', 'Agent']],
        body: rows,
        styles: { fontSize: 9 },
        headStyles: { fillColor: [13, 110, 253] },
    });

    doc.save(`clients_redevables_${magasin ?? 'export'}.pdf`);
};

const SoldeClient = ({ idmagasin }) => {
    const profile = decryptData('user_profile');
    if (!idmagasin) {
        idmagasin = profile.idmagasin
    }
    let { data: clients, isloading } = UseFetch(`clients/solde/${idmagasin}`);
    const [totalDette, settotalDette] = useState(0);
    const tableRef = useRef()
    clients?.sort((a, b) => a.solde - b.solde)
    useEffect(() => {
        settotalDette(clients?.reduce((previousValue, current) => { return (previousValue) + (+current.solde) }, 0))
    }, [clients])
    $(tableRef.current).DataTable()


    return (
        isloading ? <Loading /> : clients?.length ? <div className="row">
            <div className="d-flex justify-content-between align-items-center mb-2">
                <h3 className="text-primary fs-3 mb-0">Liste des client redevables</h3>
                <button className="btn btn-danger" onClick={() => exportClientsPDF(clients, profile.magasin, totalDette)}>
                    Exporter PDF
                </button>
            </div>
            <div className="alert alert-danger fw-bold fs-5 mb-3">
                Total des dettes : {totalDette?.toLocaleString()} GNF
            </div>
            <div className="table-responsive">
                <table ref={tableRef} className="table table-hover table-striped table-bordered" >
                    <thead className="table-primary">
                        <tr>
                            <th>N°</th>
                            <th>CLIENT</th>
                            <th>TELEPHONE</th>
                            <th>ADRESSE</th>
                            <th>DETTES</th>
                            <th>AGENT</th>
                            <th className="text-end">ACTIONS</th>
                        </tr>
                    </thead>
                    <tbody className="plage">
                        {
                            clients.map((sol, ind) => (
                                sol.creditTotal > 0 && <tr key={ind} className="tr">
                                    <td>{ind + 1}</td>
                                    <td className="critere">{sol.client}</td>
                                    <td>{sol.telephone}</td>
                                    <td>{sol.adresse}</td>
                                    <td>{(+sol.creditTotal)?.toLocaleString()} GNF</td>
                                    <td>{(sol.agent)?.toUpperCase()}</td>
                                    <td className="text-end">
                                        <NavLink to={`/mag/${idmagasin}/client/${sol.id}/factures`} className="btn btn-success"  >
                                            Voir factures
                                        </NavLink>
                                    </td>
                                </tr>
                            ))
                        }
                        {/* <tr className="fw-bold fs-3 text-center bg-danger-subtle">
                            <td colSpan={4}>TOTAL DETTE</td>
                            <td >{totalDette?.toLocaleString()} GNF</td>
                        </tr> */}
                    </tbody>
                </table>
            </div>
        </div> : <div className="row p-2 bg-danger-subtle text-danger justify-content-center fs-3">Aucun client trouvé!</div>
    );
}

export default SoldeClient;